import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Camera, Map, Route as RouteIcon, FileText, Receipt, Calendar, ArrowLeft, Settings } from 'lucide-react';
import CameraMenuModal from './CameraMenuModal';

const MileageLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showCameraMenu, setShowCameraMenu] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Main Content */}
      <main className="pb-32">
        <Outlet context={{ showCameraMenu, setShowCameraMenu }} />
      </main>

      {/* Camera Menu Modal */}
      <CameraMenuModal 
        isOpen={showCameraMenu} 
        onClose={() => setShowCameraMenu(false)}
        onSuccess={() => {
          // Optionally refresh data after successful upload
          window.location.reload();
        }}
      />

      {/* TWO SEPARATE Bottom Bars - Visible on ALL pages */}
      
      {/* Upper Bar (ULTRA THIN): Back | Camera (Protruding Orange - MUCH BIGGER) | Settings */}
      <div className="fixed bottom-[88px] left-0 right-0 z-20">
        <div className="max-w-md mx-auto px-3">
          <div 
            className="relative rounded-2xl shadow-lg"
            style={{ backgroundColor: '#e8e8e8', border: '2px solid #ee7203' }}
          >
            {/* Protruding Orange Camera Button - MUCH BIGGER */}
            <button
              onClick={() => setShowCameraMenu(true)}
              className="absolute left-1/2 transform -translate-x-1/2 -top-11 rounded-2xl p-5 shadow-2xl hover:scale-110 transition-all"
              style={{ backgroundColor: '#ee7203' }}
            >
              <Camera className="w-11 h-11 text-white" />
            </button>

            {/* Back and Settings Buttons - ULTRA THIN */}
            <div className="flex items-center justify-between px-6 py-0">
              <button
                onClick={() => navigate('/company-car')}
                className="flex items-center gap-1 text-gray-700 hover:text-[#ee7203] transition-colors py-1"
              >
                <ArrowLeft className="w-4 h-4" />
                <span className="text-xs font-medium">Back</span>
              </button>
              
              <div className="w-16"></div> {/* Spacer for camera */}
              
              <button
                onClick={() => navigate('/mileage-tracker/settings')}
                className="flex items-center gap-1 text-gray-700 hover:text-[#ee7203] transition-colors py-1"
              >
                <Settings className="w-4 h-4" />
                <span className="text-xs font-medium">Settings</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Lower Bar (Main Menu): 5 Menu Items - Highlight active page */}
      <div className="fixed bottom-0 left-0 right-0 z-10">
        <div className="max-w-md mx-auto px-3 pb-2">
          <div 
            className="rounded-2xl shadow-lg"
            style={{ backgroundColor: '#e8e8e8', border: '2px solid #ee7203' }}
          >
            <div className="grid grid-cols-5 gap-1 px-2 py-2.5">
              {/* Dashboard */}
              <button
                onClick={() => navigate('/mileage-tracker')}
                className="flex flex-col items-center gap-0.5 py-1.5 rounded-xl transition-all"
                style={{ backgroundColor: location.pathname === '/mileage-tracker' ? '#ee7203' : 'transparent' }}
              >
                <Map className="w-5 h-5" style={{ color: location.pathname === '/mileage-tracker' ? 'white' : '#4b5563' }} />
                <span className="text-[10px] font-medium" style={{ color: location.pathname === '/mileage-tracker' ? 'white' : '#4b5563' }}>Dashboard</span>
              </button>

              {/* New Trip */}
              <button
                onClick={() => navigate('/mileage-tracker/create-trip')}
                className="flex flex-col items-center gap-0.5 py-1.5 rounded-xl transition-colors hover:bg-gray-300"
                style={{ backgroundColor: location.pathname === '/mileage-tracker/create-trip' ? '#ee7203' : 'transparent' }}
              >
                <RouteIcon className="w-5 h-5" style={{ color: location.pathname === '/mileage-tracker/create-trip' ? 'white' : '#4b5563' }} />
                <span className="text-[10px]" style={{ color: location.pathname === '/mileage-tracker/create-trip' ? 'white' : '#4b5563' }}>New Trip</span>
              </button>

              {/* Trips */}
              <button
                onClick={() => navigate('/mileage-tracker/trips')}
                className="flex flex-col items-center gap-0.5 py-1.5 rounded-xl transition-colors hover:bg-gray-300"
                style={{ backgroundColor: location.pathname === '/mileage-tracker/trips' ? '#ee7203' : 'transparent' }}
              >
                <FileText className="w-5 h-5" style={{ color: location.pathname === '/mileage-tracker/trips' ? 'white' : '#4b5563' }} />
                <span className="text-[10px]" style={{ color: location.pathname === '/mileage-tracker/trips' ? 'white' : '#4b5563' }}>Trips</span>
              </button>

              {/* Receipts */}
              <button
                onClick={() => navigate('/mileage-tracker/receipts')}
                className="flex flex-col items-center gap-0.5 py-1.5 rounded-xl transition-colors hover:bg-gray-300"
                style={{ backgroundColor: location.pathname === '/mileage-tracker/receipts' ? '#ee7203' : 'transparent' }}
              >
                <Receipt className="w-5 h-5" style={{ color: location.pathname === '/mileage-tracker/receipts' ? 'white' : '#4b5563' }} />
                <span className="text-[10px]" style={{ color: location.pathname === '/mileage-tracker/receipts' ? 'white' : '#4b5563' }}>Receipts</span>
              </button>

              {/* Monthly */}
              <button
                onClick={() => navigate('/mileage-tracker/monthly')}
                className="flex flex-col items-center gap-0.5 py-1.5 rounded-xl transition-all"
                style={{ backgroundColor: location.pathname === '/mileage-tracker/monthly' ? '#ee7203' : 'transparent' }}
              >
                <Calendar className="w-5 h-5" style={{ color: location.pathname === '/mileage-tracker/monthly' ? 'white' : '#4b5563' }} />
                <span className="text-[10px] font-medium" style={{ color: location.pathname === '/mileage-tracker/monthly' ? 'white' : '#4b5563' }}>Monthly</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MileageLayout;
